import React, { useState } from "react";
import { View, Text, Pressable } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";
import Icons from "@/assets/icons";

interface OptionItemProps {
  label: string;
  selected: boolean;
  onPress: () => void;
}

const OptionItem = ({ label, selected, onPress }: OptionItemProps) => (
  <Pressable
    style={[styles.optionItem, selected && styles.optionItemSelected]}
    onPress={onPress}
  >
    <Text style={styles.optionLabel}>{label}</Text>
    {selected && (
      <View style={styles.checkmark}>
        <Icons.Check width={14} height={14} />
      </View>
    )}
  </Pressable>
);

interface OnboardSlide6Props {
  onSelectionChange?: (selected: string | null) => void;
}

const OnboardSlide6 = ({ onSelectionChange }: OnboardSlide6Props) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);

  const options = [
    { id: "0to50", label: "$0 - $50 per month" },
    { id: "50plus", label: "$50+ / month" },
    { id: "notsure", label: "Not sure" },
  ];

  const selectOption = (optionId: string) => {
    const newSelected = selectedOption === optionId ? null : optionId;
    setSelectedOption(newSelected);
    onSelectionChange?.(newSelected);
  };

  return (
    <View style={styles.container}>
      <View style={styles.textContainer}>
        <Text style={styles.title}>
          How much are you spending on subscriptions?
        </Text>
        <Text style={styles.subtitle}>Apps, music, streaming, etc.</Text>
      </View>

      <View style={styles.optionsList}>
        {options.map((option) => (
          <OptionItem
            key={option.id}
            label={option.label}
            selected={selectedOption === option.id}
            onPress={() => selectOption(option.id)}
          />
        ))}
      </View>
    </View>
  );
};

export default OnboardSlide6;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 0,
    paddingTop: 30,
  },
  textContainer: {
    gap: 16,
    marginBottom: 25,
  },
  title: {
    fontFamily: FontFamilies.Inter.SemiBold,
    fontSize: 32,
    lineHeight: 38,
    color: "#161D14",
    textAlign: "left",
  },
  subtitle: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 15,
    lineHeight: 24,
    color: "#161D14",
    textAlign: "left",
    opacity: 0.7,
  },
  optionsList: {
    gap: 8,
  },
  optionItem: {
    backgroundColor: "#F3F3F3",
    borderRadius: 12,
    paddingVertical: 20,
    paddingHorizontal: 20,
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  optionItemSelected: {
    backgroundColor: "#F3F3F3",
    borderWidth: 2,
    borderColor: "rgba(15, 145, 41, 0.2)",
  },
  optionLabel: {
    fontFamily: FontFamilies.Inter.Medium,
    fontSize: 16,
    color: "#161D14",
    textAlign: "center",
  },
  checkmark: {
    position: "absolute",
    top: 5,
    right: 5,
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: "#C6F4A8",
    justifyContent: "center",
    alignItems: "center",
  },
});
